@if (templates$ | async; as templatesWithContext) {
  <pr-template-selector
    displayMode="menuItem"
    [templates]="templatesWithContext.templates"
    [contextOptions]="templatesWithContext.contextOptions"
    [resetOnSelection]="true"
    (menuOpened)="onMenuOpened()"
    (templateSelected)="onTemplateSelected($event)"
  />
}
